
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ModifiedRankinScale',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/Chart_ModifiedRankinScale.vue